<script lang="ts">
  import FormModal from '../common/modal/FormModal.svelte';
  import { resetLeaderboard } from '$lib/api/classes';

  interface Props {
    isResettingLeaderboard: boolean;
    classId: number;
  }
  let { isResettingLeaderboard = $bindable(), classId }: Props = $props();
</script>

<FormModal
  formId="bulk_action_confirm"
  onclose={() => (isResettingLeaderboard = false)}
  header="Reset Leaderboard"
  invalidateUrl={url => url.pathname.startsWith('/api/classes')}
  scrollable={false}
  submitBtnLabel="Reset"
  onsubmit={async () => {
    await resetLeaderboard(classId);
    return true;
  }}
>
  <p>
    Reset leaderboard of class? All logged skills will be cleared. Scores will be reset to 0. Students' access to the
    class will remain, and their opt-in status will not change.
  </p>
</FormModal>
